import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import useWindowSize from '../../hooks/useWindowSize'
import { ClipLoader } from 'react-spinners'

const PlaceHolderImage = ({ imageUrl, handleUnlock, isModalLoading }) => {
  const { width, height } = useWindowSize()
  return (
    <div className="w-full h-[215px] md:h-[380px] rounded-[12px] overflow-hidden relative">
      <div className='bg-black/50 backdrop-blur-md absolute flex flex-col leading-none justify-center items-center top-0 left-0 w-full h-full' onClick={handleUnlock}>
        <img src="https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/Group%2023607.webp" width={width < 768 ? 102 : 182} height={height < 768 ? 70 : 125} alt="placeholder" />
        <div className=' text-[24px] md:text-[32px] font-bold text-white mt-5'>This Lesson Is Locked!</div>
        {isModalLoading ? <ClipLoader size={20} color="#fff" className='mt-3' /> : <span className='text-[12px] md:text-[20px] text-white/70 mt-3 '>Unlock the course now to continue watching <FontAwesomeIcon icon={faArrowRight} /></span>}
      </div>
      <img src={imageUrl} alt="placeholder" className="w-full h-full object-cover" />
    </div>
  )
}

export default PlaceHolderImage